/* eslint-disable camelcase */

import { PlanRepository } from '../plan-repository';
import type { Plan } from '../plan';

// This function mainly exists as part of our Angular migration efforts
// In particular, the Plan Service - See https://hotjar.atlassian.net/browse/CHAP-865.
// It provides a framework agnostic way of looking up a plan by its ID
// If you are working in our React codebase, rather use the following hook:
// import { usePlanRepository } from '@hotjar/webapp/hooks/usePlanRepository';
export function planById(id: string | undefined): Plan | undefined {
  let plan;
  // PlanRepository returns a default plan if no ID is provided
  // In order to stay consistent with the legacy implementation,
  // we prefer to return undefined here if the id param is undefined
  if (!id) {
    return plan;
  }
  const { available_plans = [] } = window.settings ?? {};
  const planRepository = new PlanRepository(available_plans);
  try {
    plan = planRepository.byId(id);
    return plan;
  } catch {
    // We are explicitly returning undefined here,
    // in order to ensure consistency with the legacy implementation
    // inside of the Angular service
    return plan;
  }
}
